import { AfterViewInit, Component, OnInit, ViewChild, inject, ChangeDetectionStrategy } from "@angular/core";
import { Router, Scroll } from "@angular/router";
import { MatSidenav, MatSidenavContent } from "@angular/material/sidenav";
import { filter } from "rxjs/operators";
import { LorenBreakpointObserverService } from "../../../../services/loren-breakpoint-observer-service/loren-breakpoint-observer.service";
import { LorenNavService } from "./services/loren-nav-service/loren-nav.service";
import { LorenScrollService } from "../../../../services/loren-scroll-service/loren-scroll.service";
import { LorenDetailsOutletService } from "../../../../services/loren-details-outlet-service/loren-details-outlet.service";
import { LorenBaseFeature } from "../../../../base-components/loren-base-feature/loren-base-feature";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: "loren-nav",
  templateUrl: "./loren-nav.component.html",
  styleUrls: ["./loren-nav.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LorenNavComponent
  extends LorenBaseFeature
  implements OnInit, AfterViewInit
{
  private router = inject(Router);
  protected breakpointObserver: LorenBreakpointObserverService;
  private detailsOutletService = inject(LorenDetailsOutletService);
  private scrollService = inject(LorenScrollService);
  protected lorenNavService: LorenNavService;

  sidenavState = false;
  collapsed = false;
  detailsOutletState$ = this.detailsOutletService.getCurrentState();

  @ViewChild(MatSidenavContent) content;
  @ViewChild(MatSidenav) drawer;
  @ViewChild("sidenavContainer") sidenavContainer;
  @ViewChild("lorenToolbar") lorenToolbar;
  @ViewChild("notifications") detailsOutlet: MatSidenav;

  constructor() {
    const breakpointObserver = inject(LorenBreakpointObserverService);
    const lorenNavService = inject(LorenNavService);

    super();

    this.breakpointObserver = breakpointObserver;
    this.lorenNavService = lorenNavService;
  }

  ngOnInit(): void {

      this.breakpointObserver
          .getHandsetStateSubscription()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((res) => (this.isHandset = res));
  }

  ngAfterViewInit(): void {
    this.scrollService.setScrollableContent(this.content.elementRef);

      this.router.events
          .pipe(
              takeUntilDestroyed(this.destroyRef),
              filter((e) => e instanceof Scroll)
          )
          .subscribe((e: Scroll) => {
              if (e.position) {
                  // backward navigation
                  // viewportScroller.scrollToPosition(e.position);
              } else if (e.anchor) {
                  // anchor navigation
                  // viewportScroller.scrollToAnchor(e.anchor);
              } else {
                  // forward navigation
                  this.scrollService.scrollToTop();
              }
          });

      this.lorenNavService.sidenavControl$()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((state) => {
              if (state === false) {
                  this.drawer.close();
              } else if (state === true) {
                  this.drawer.open();
              }
          });
  }

  emitSidenavToggled() {
    this.sidenavState = !this.sidenavState;
    this.lorenNavService.setSidenavToggleStateChanged(this.sidenavState);
    window.dispatchEvent(new Event("resize"));
  }

  toggleSidenav() {
    this.collapsed = !this.collapsed;
    this.content.elementRef.nativeElement.style.marginLeft = this.collapsed
      ? "80px"
      : "215px";
  }

  handleNotificationsOpened(event) {
    if (!event) {
      this.detailsOutletService.toggleState(false);
      this.detailsOutletService.resetDetailsOutlet();
    }
  }
}
